<template>
  <div class="row px-2">
    <a v-if="menuItem.path" 
      :href="btnLink" :class="[menuClass, 'btn']" download>
      <i v-if="menuItem.icon" :class="[menuItem.icon, 'me-2']"></i>
      {{ menuItem.title }}
    </a>
    <a href="#" v-if="!menuItem.path" 
      data-fancybox="dialog" data-src="#dialog-content" :class="[menuClass, 'btn']">
      <i v-if="menuItem.icon" :class="[menuItem.icon, 'me-2']"></i>
      {{ menuItem.title }}
    </a>
    <div 
      v-if="!menuItem.path" 
      id="dialog-content" style="display:none;" v-html="menuItem.text">
    </div>
  </div>
</template>

<script>
export default {
  name: 'PdfMenuItem',
  props: ['menuItem', 'menuClass'],
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  computed: {
    btnLink() {
      return this.publicPath + this.menuItem.path;
    }
  }
}
</script>

<style>
</style>

<style scoped>
</style>
